<template>
    <div class="row sintese">
        <div class="sm-12">
            <p class="text-primary-darker-1 text-center">
                <strong>SÍNTESE</strong>
            </p>
            <div class="responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th align="left">DESCRIÇÃO</th>
                            <th align="right" width="200">VALOR(R$)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>SALDO ANTERIOR</td>
                            <td align="right" :class="{'text-red': sintese.Totalizacao.ValorSaldoAnterior < 0, 'text-green': sintese.Totalizacao.ValorSaldoAnterior > 0}">{{ sintese.Totalizacao.ValorSaldoAnterior | number_format }}</td>
                        </tr>
                        <tr >
                            <td>RECEITAS</td>
                            <td align="right" :class="{ 'text-red': sintese.Totalizacao.ValorReceitas < 0, 'text-green': sintese.Totalizacao.ValorReceitas > 0 }">{{ sintese.Totalizacao.ValorReceitas | number_format }}</td>
                        </tr>
                        <tr >
                            <td>DESPESAS</td>
                            <td align="right" :class="{ 'text-red': sintese.Totalizacao.ValorDespesas < 0, 'text-green': sintese.Totalizacao.ValorDespesas > 0 }">{{ sintese.Totalizacao.ValorDespesas | number_format }}</td>
                        </tr>
                        <tr >
                            <td>SALDO ATUAL</td>
                            <td align="right" :class="{ 'text-red': sintese.Totalizacao.ValorSaldoFinal < 0, 'text-green': sintese.Totalizacao.ValorSaldoFinal > 0 }">{{ sintese.Totalizacao.ValorSaldoFinal | number_format }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colspan="2"><b>SUBCONTAS</b></td>
                        </tr>
                        <tr v-for="subconta in sintese.Subcontas" :key="subconta.id">
                            <td>{{ subconta.Descricao }}</td>
                            <td align="right" :class="{ 'text-red': subconta.Valor < 0, 'text-green': subconta.Valor > 0 }" >{{ subconta.Valor | number_format }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sintese'],
    filters: {
        number_format(value) {
            return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
        }
    }
}
</script>